import * as types from "../actions/ActionTypes"
import initialState from "./initialState";
import {PATCH_USER, SET_USER} from "../actions/userActions";

export default function (state = initialState.user, action) {
    switch (action.type) {
        case SET_USER : {
            const {data} = action.payload;
            return {...data};
        }
        case PATCH_USER : {
            const {data} = action.payload;
            return {
                ...state,
                ...data,
            };
        }
        default:
            return state
    }
}
